var searchKeyWord = '';

function setKeyWord(word){
    searchKeyWord = word;
}

function getKeyword(){
    return searchKeyWord;
}

export  {getKeyword, setKeyWord};